import { defineStore } from 'pinia';
interface BasicState {
    /**
     * 是否折叠面板
     */
    isMenuCollapse: boolean;
    /**
     * 是否展示好友面板
     */
    showFriendList: boolean;
    /**
     * 好友对局申请签名
     */
    inviteSign: string;
    /**
     * 好友申请总数
     */
    friendApplyCount: number;
}

export const useBasicStore = defineStore({
    id: 'app-basic',
    persist: true,
    state: (): BasicState => ({
        isMenuCollapse: false,
        showFriendList: false,
        inviteSign: '',
        friendApplyCount: 0,
    }),
    actions: {
        setMenuCollapse(status: boolean) {
            this.isMenuCollapse = status;
        },
    },
});
